<!--Dashboard tabs-->
<div class="dashboard-tab">
  <ul class="nav nav-pills" id="pills-tab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-dashboard"
        type="button" role="tab" aria-controls="pills-home" aria-selected="true" (click)="toggleTableOrGraph(1)">
        Dashboard
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-report" type="button"
        role="tab" aria-controls="pills-profile" aria-selected="false" (click)="toggleTableOrGraph(0)">
        Report
      </button>
    </li>
  </ul>
</div>

<section>
  <div class="production-overview mt-3" style="background: #fff">
    <div class="dashboard-filter d-flex flex-wrap flex-lg-nowrap gap-2 mb-3" style="white-space: nowrap">
      <div class="d-flex nav-dropdowns">
        <div class="filter-wrapper me-2 mb-2">
          <div class="dropdown stores" style="width: unset !important">
            <div class="report-type" data-bs-toggle="dropdown">
              <small class="filter-text">
                {{ storeName }}
              </small>
              <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
                <img src="assets/pos/products/ic_upDown.svg" />
              </button>
            </div>

            <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
              <ul>
                <li (click)="selectAllStores()">
                  <a class="dropdown-item">All stores</a>
                </li>
                <li *ngFor="let str of stores" (click)="setFilterNames(str, 1)">
                  <a class="dropdown-item">{{ str.storeName }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="filter-wrapper me-2 mb-2">
          <div class="dropdown departments" style="width: unset !important">
            <div class="report-type" data-bs-toggle="dropdown">
              <small class="filter-text">{{ deptName }}</small>
              <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
                <img src="assets/pos/products/ic_upDown.svg" />
              </button>
            </div>

            <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
              <ul>
                <li style="border-bottom: 1px solid #d4d4d4">
                  <a class="dropdown-item">
                    <div class="form-check d-flex" style="cursor: pointer">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                        [checked]="headerCheckboxSelected" (click)="toggleAllCheckboxes()" />
                      <label class="form-check-label" for="flexCheckChecked">
                        Select all Departments ({{
                        mainDepartmentList.length
                        ? mainDepartmentList.length
                        : 0
                        }})
                      </label>
                    </div>
                  </a>
                </li>
                <li *ngFor="let dept of mainDepartmentList; let i = index">
                  <a class="dropdown-item">
                    <div class="form-check d-flex">
                      <input class="form-check-input" type="checkbox" value="" id="deptCheckbox{{ i }}"
                        [checked]="selectedDepartmentIds.includes(dept.departmentId)"
                        (change)="setFilterNames(dept, 2)" />
                      <label class="form-check-label" [for]="'deptCheckbox' + i">
                        {{ dept.departmentDescr }}
                      </label>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Active filter -->
        <div class="filter-wrapper me-2 mb-2">
          <div class="dropdown stores" style="width: unset !important">
            <div class="report-type" data-bs-toggle="dropdown">
              <small class="filter-text">
                {{ activeStatusLabel }}
              </small>
              <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
                <img src="assets/pos/products/ic_upDown.svg" />
              </button>
            </div>
            <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
              <ul>
                <li (click)="setActiveStatus(null, 'All Items')">
                  <a class="dropdown-item">All Items</a>
                </li>
                <li (click)="setActiveStatus(true, 'Active')">
                  <a class="dropdown-item">Active</a>
                </li>
                <li (click)="setActiveStatus(false, 'Inactive')">
                  <a class="dropdown-item">Inactive</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="filter-wrapper date-range me-2 mb-2" (click)="openCalender()" style="cursor: pointer">
          <div class="dropdown" style="width: unset !important">
            <div class="d-flex ps-0" data-bs-toggle="dropdown" style="width: 18rem">
              <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false" style="
                  border-radius: 8px 0px 0px 8px;
                  border-right: 1px solid #d4d4d4;
                  background: #f5f5f5;
                ">
                <img src="assets/pos/products/ic_leftArrow.svg" />
              </button>
              <input type="text" name="daterangeInput" daterangepicker #dateRange [options]="options"
                (selected)="selectedDate($event, daterange)" style="width: 19rem;height: 100%;" />
              <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false" style="
                  border-radius: 0px 8px 8px 0px;
                  border-left: 1px solid #d4d4d4;
                  background: #f5f5f5;
                ">
                <img src="assets/pos/products/ic_rightArrow.svg" />
              </button>
            </div>
          </div>
        </div>

        <!--week color -->
        <div class="filter-wrapper me-2 mb-2" *ngIf="showWeekColor">
          <div class="dropdown stores" style="width: unset !important">
            <div class="report-type" data-bs-toggle="dropdown">
              <small class="filter-text">
                {{ weekColor }}
              </small>
              <button class="btn text-nowrap" type="button" id="dropdownMenuButton" aria-expanded="false">
                <img src="assets/pos/products/ic_upDown.svg" />
              </button>
            </div>
            <div class="dropdown-menu p-2 mt-1" aria-labelledby="dropdownMenuButton" style="width: 100%">
              <ul>
                <li (click)="selectAllcolors()">
                  <a class="dropdown-item">All Week Colors</a>
                </li>
                <li *ngFor="let wk of weekColorsList" (click)="setFilterNames(wk, 5)">
                  <a class="dropdown-item" [style.backgroundColor]="wk.color">{{
                    wk.displayName
                    }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="create-btn run-report-btn ms-2 c-pt" [class.is-loading]="isLoading" (click)="runReport()">
          <span class="run-spinner" *ngIf="isLoading"></span>
          <img *ngIf="!isLoading" src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
          {{ isLoading ? "Running…" : "Run Report" }}
        </div>
      </div>
    </div>

    <!-- empty state: shown until the report is run -->
    <div class="report-empty-state" *ngIf="!reportHasRun">
      <img src="assets/dashboard/noData.svg" alt="" />
      <h5>Ready when you are</h5>
      <p>
        Adjust the filters above, then click <strong>Run Report</strong> to
        generate the production overview.
      </p>
      <div class="create-btn run-report-btn c-pt" (click)="runReport()">
        <img src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        Run Report
      </div>
    </div>

    <div class="tab-content mt-3" id="pills-tabContent" style="position: relative" [hidden]="!reportHasRun">
      <div class="tab-pane fade show active" id="pills-dashboard" role="tabpanel" aria-labelledby="pills-home-tab"
        tabindex="0">
        <!--dashboard tab-->
        <section class="data-found-section">
          <div class="main-content-wrapper no-scrollbar p-0">
            <div class="stat-text-wrapper">
              <div class="content" style="background: #e3f5ff">
                <div class="text-content mt-2">
                  <small>Total Items Entry</small>
                  <h1 class="mt-2">
                    {{ mainStats.qty ? (mainStats.qty | number) : 0 }}
                  </h1>
                </div>
                <img src="assets/dashboard/ic_totalEntry.svg" />
              </div>

              <div class="content" style="background: #e5ecf6">
                <div class="text-content mt-2">
                  <small>Total Value of Items</small>
                  <h1 class="mt-2">
                    {{ this.deptPrice ? (this.deptPrice | currency) : 0 }}
                  </h1>
                </div>
                <img src="assets/dashboard/ic_totalValue.svg" />
              </div>

              <div class="content" style="background: #e3f5ff">
                <div class="text-content mt-2">
                  <small>Category</small>
                  <h1 class="mt-2">
                    {{
                    mainStats.categoryCnt > 0
                    ? (mainStats.categoryCnt | number)
                    : 0
                    }}
                  </h1>
                </div>
                <img src="assets/dashboard/ic_categories.svg" />
              </div>
            </div>

            <div class="container-fluid split-chart" style="margin-top: 1rem">
              <div class="special-price-chart wd-4" [ngClass]="{ showStore: isStoreNull }">
                <div class="category brand">
                  <div class="cahrt-text d-flex justify-content-between">
                    <small class="chart-title">Total items entry at store level
                    </small>
                    <small class="chart-title"><span style="font-weight: 400">Total</span> :
                      {{ this.storeQty ? (this.storeQty | number) : "" }}</small>
                  </div>
                  <div class="platform-chart mt-3" [ngClass]="{ hideNoDataFound: isStoreData }">
                    <canvas id="totalItemV3"></canvas>
                  </div>

                  <div class="d-flex flex-column text-center justify-content-center h-100"
                    [ngClass]="{ hideNoDataFound: !isStoreData }">
                    <img src="assets/dashboard/noData.svg" style="height: 145px" />
                  </div>
                </div>
              </div>

              <div class="category" [ngClass]="{ 'wd-8': !isStoreNull, 'wd-12': isStoreNull }">
                <div class="chart-text d-flex justify-content-between">
                  <h2 class="chart-title">
                    Total Items Entry per Department and Category
                  </h2>
                  <small class="chart-title"><span style="font-weight: 400">Total</span> :
                    {{ this.deptQty ? (this.deptQty | number) : "" }}</small>
                </div>

                <div class="mt-3" [ngClass]="{ hideNoDataFound: isDeptData }">
                  <canvas id="deptItemV3"></canvas>
                </div>

                <div class="d-flex flex-column text-center justify-content-center h-100"
                  [ngClass]="{ hideNoDataFound: !isDeptData }">
                  <img src="assets/dashboard/noData.svg" style="height: 145px" />
                </div>
              </div>
            </div>

            <div class="container-fluid split-chart" style="margin-top: 1rem">
              <div class="special-price-chart wd-4" [ngClass]="{ showStore: isStoreNull }">
                <div class="category">
                  <div class="cahrt-text d-flex justify-content-between">
                    <h2 class="chart-title">
                      Total value of items at store level
                    </h2>
                    <small class="chart-title"><span style="font-weight: 400">Total</span> :
                      {{
                      this.storePrices ? (this.storePrices | currency) : ""
                      }}</small>
                  </div>

                  <div class="platform-chart brand mt-3" [ngClass]="{ hideNoDataFound: isStoreData }">
                    <canvas id="totalItemValueV3"></canvas>
                  </div>

                  <div class="d-flex flex-column text-center justify-content-center h-100"
                    [ngClass]="{ hideNoDataFound: !isStoreData }">
                    <img src="assets/dashboard/noData.svg" style="height: 145px" />
                  </div>
                </div>
              </div>

              <div class="category" [ngClass]="{ 'wd-8': !isStoreNull, 'wd-12': isStoreNull }">
                <div class="cahrt-text d-flex justify-content-between">
                  <h2 class="chart-title">
                    Total value of items entry per department and category
                  </h2>
                  <small class="chart-title"><span style="font-weight: 400">Total</span> :
                    {{
                    this.deptPrice ? (this.deptPrice | currency) : ""
                    }}</small>
                </div>
                <div [ngClass]="{ hideNoDataFound: isDeptData }" class="mt-3">
                  <canvas id="deptValueV3"></canvas>
                </div>

                <div class="d-flex flex-column text-center justify-content-center h-100"
                  [ngClass]="{ hideNoDataFound: !isDeptData }">
                  <img src="assets/dashboard/noData.svg" style="height: 145px" />
                </div>
              </div>
            </div>

            <div class="print-cahrt" style="margin-top: 1rem">
              <div class="category brand">
                <div class="cahrt-text d-flex justify-content-between">
                  <h2 class="chart-title">Productivity at employee level</h2>
                  <small class="chart-title"><span style="font-weight: 400">Total</span> :
                    {{ empQty ? empQty : "" }}</small>
                </div>
                <div class="mt-3">
                  <canvas id="productivityEmpV3" class="pb-3" [ngClass]="{ hideNoDataFound: isEmpData }"></canvas>
                </div>

                <div class="d-flex flex-column text-center justify-content-center h-100"
                  [ngClass]="{ hideNoDataFound: !isEmpData }">
                  <img src="assets/dashboard/noData.svg" style="height: 145px" />
                </div>
              </div>
            </div>

            <div class="print-cahrt" style="margin-top: 1rem">
              <div class="category brand">
                <div>
                  <div class="cahrt-text d-flex justify-content-between">
                    <h2 class="chart-title">Productivity at Brand level</h2>
                    <small class="chart-title"><span style="font-weight: 400">Total</span> :
                      {{
                      this.dashboardDetails?.brand?.length > 0
                      ? (this.qtyTotal | number)
                      : ""
                      }}</small>
                  </div>

                  <div class="mt-3">
                    <canvas id="productivityBrandV3" [ngClass]="{ hideNoDataFound: isBrandData }"></canvas>
                  </div>
                </div>

                <div class="d-flex flex-column text-center justify-content-center h-100"
                  [ngClass]="{ hideNoDataFound: !isBrandData }">
                  <img src="assets/dashboard/noData.svg" style="height: 145px" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="tab-pane fade" id="pills-report" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
        <!--Table view-->

        <section>
          <div class="table-container" style="height: calc(100vh - 250px)"
            *ngIf="dashboardTabledata?.length; else noReportRows">
            <table class="table table-condensed parent-table">
              <thead class="main-head sticky-top">
                <tr>
                  <th class="dept-col">
                    Departments
                    <img src="assets/dashboard/arrowUpDown.svg" class="sort-icon"
                      (click)="toggleSortDirection('dept')" />
                  </th>
                  <th [ngClass]="{
    'ps-3': isSingleStore,
    'last-td-padding': last
  }" [style.width]="'calc(75% / ' + (StoreNames?.length || 1) + ')'"
                    [style.text-align]="isSingleStore ? 'left' : 'right'"
                    *ngFor="let store of StoreNames; let last = last">
                    {{ store }}
                    <img src="assets/dashboard/arrowUpDown.svg" (click)="toggleSortDirection(store)"
                      class="sort-icon" />
                  </th>

                  <th class="text-end pe-5 total-col">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody *ngFor="let dept of dashboardTabledata; let i = index" id="mainParent">
                <tr class="accordion-toggle department-row" data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#userDetails' + i">
                  <td class="d-flex departmentName" data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#userDetails' + i">
                    <div>
                      <button class="accordian-btn me-2">
                        <img src="assets/dashboard/ic_activation.svg" />
                      </button>
                      <span>{{ dept.department }}</span>
                    </div>
                  </td>
                  <td *ngFor="
                      let store of StoreNames;
                      let last = last;
                      let i = index
                    " [ngClass]="{
                      'ps-3': isSingleStore,
                      'overflow-auto': true,
                      'last-td-padding': last
                    }" [style.text-align]="isSingleStore ? 'left' : 'right'">
                    <span [style.padding-left]="isSingleStore ? '11%' : ''">{{
                      storeId
                      ? (getDeptUserWiseQty(dept, store) | number)
                      : (getDeptStoreWiseQty(dept, store) | number)
                      }}</span>
                  </td>
                  <td class="text-end pe-5 total-col" data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#userDetails' + i">
                    {{ calculateRowTotal(dashboardTabledata[i].qty) }}
                  </td>
                </tr>
                <tr>
                  <td colspan="12" class="hiddenRow px-0 py-0">
                    <div class="accordian-body collapse" [attr.id]="'userDetails' + i" data-bs-parent="#mainParent">
                      <table class="table mb-0" *ngFor="
                          let ctg of dashboardTabledata[i].categories;
                          let j = index
                        ">
                        <thead>
                          <tr class="ctg-row">
                            <td class="ps-4">
                              {{ ctg.cname }}
                            </td>
                            <td [ngClass]="{
    'ps-3': isSingleStore,
    'last-td-padding': last
  }" [style.width]="'calc(75% / ' + (StoreNames?.length || 1) + ')'" *ngFor="let store of StoreNames; let last = last"
                              [style.text-align]="isSingleStore ? 'left' : 'right'">
                              <span [style.padding-left]="isSingleStore ? '11%' : ''">
                                {{
                                storeId
                                ? getDeptUserWiseQty(ctg, store)
                                : getDeptStoreWiseQty(ctg, store)
                                }}
                              </span>
                            </td>

                            <td class="text-end pe-5 total-col">
                              {{
                              calculateRowTotal(
                              dashboardTabledata[i].categories[j].qty
                              )
                              }}
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody class="bottom-total">
                <tr class="total-row">
                  <td class="text-start ps-4 dept-col">
                    Total
                  </td>
                  <td *ngFor="
                      let store of StoreNames;
                      let last = last;
                      let i = index
                    " [ngClass]="{
                      'ps-3': isSingleStore,
                      'overflow-auto': true,
                      'last-td-padding': last
                    }" [style.text-align]="isSingleStore ? 'left' : 'right'">
                    <span [style.padding-left]="isSingleStore ? '11%' : ''">{{
                      calculateColumnTotal(store) | number
                      }}</span>
                  </td>
                  <td class="pe-5 total-col">
                    {{ tableDataTotalQty }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noReportRows>
            <div class="report-empty-state report-empty-state--inline">
              <img src="assets/dashboard/noData.svg" alt="" />
              <h5>No data found</h5>
              <p>
                No production activity matches the selected filters and date
                range. Adjust them and run the report again.
              </p>
            </div>
          </ng-template>
        </section>
      </div>

      <!--loader-->
      <div class="overlay" *ngIf="isLoading">
        <div class="loader"></div>
      </div>
    </div>
  </div>
</section>
